import { Action, createReducer, on } from '@ngrx/store';
import * as ClientActions from './modal.actions';

export interface ModalState {
  open: boolean;
  close: boolean;
}

export const modalInitialState: ModalState = {
    open: false,
    close: false,
  }
;

const reducer = createReducer(
  modalInitialState,
  on(ClientActions.closeModal, (state) => ({
    ...state,
    close: true,
  })),
  on(ClientActions.openModal, (state) => ({
    ...state,
    open: true,
  })),
);

export function ModalReducer(state: ModalState | undefined, action: Action) {
  return reducer(state, action);
}
